module.exports = __webpack_public_path__ + "static/media/akareeLogo.f3a41477.svg";